<template>
  <div class="">
    <div class="right_out">
      <p class="welcome">下午好，尊敬的用户</p>
      <div class="block_wrap">
        <div class="left_block">
          <div class="flex_block">
            <div class="block" v-for="(item, index) in flexData" :key="index">
              <span class="text1">{{ item.num }}</span>
              <p class="text2">{{ item.title }}</p>
            </div>
            <div class="block" @click="goMessageList">
              <span class="text1">{{ messageNum }}</span>
              <p class="text2">消息通知</p>
            </div>
          </div>
          <div class="flex_bottom">
            <div class="tab_wrap4_wrap">
              <span class="title">通知公告</span>
              <el-tabs v-model="activeName" @tab-click="handleNotify" class="tab_wrap4">
                <el-tab-pane label="全部" name="default"></el-tab-pane>
                <el-tab-pane label="招标公告" name="招标专区"></el-tab-pane>
                <el-tab-pane label="非招标公告" name="非招标专区"></el-tab-pane>
              </el-tabs>
              <span class="detail" @click.stop="goDetail">更多></span>
            </div>
            <ul class="li_wrap re_liwrap">
              <li class="clear" v-for="(item, index) in biddlist1" :key="index" @click.stop="goInformationDetail(item.id, item.cateid)">
                <span class="type_btn">【{{ item.type }}】</span>
                <span class="li_left overell">{{ item.title }}</span>
                <span class="li_right">{{ item.date }}</span>
              </li>
            </ul>
            <div class="noneInfo" v-if="biddlist1.length == 0">sorry，暂时没有信息~</div>
          </div>
        </div>
        <div class="right_block">
          <p class="text">服务专区</p>
          <div class="row_imgs">
            <div class="img_block">
              <img src="@/assets/img/icon_guidelines.png" />
              <p>办事指引</p>
            </div>
            <div class="img_block">
              <img src="@/assets/img/icon_process.png" />
              <p>交易流程</p>
            </div>
            <div class="img_block">
              <img src="@/assets/img/icon_problem.png" />
              <p>常见问题</p>
            </div>
          </div>
          <div class="row_imgs">
            <div class="img_block">
              <img src="@/assets/img/icon_download2.png" />
              <p>资料下载</p>
            </div>
            <div class="img_block">
              <img src="@/assets/img/icon_help.png" />
              <p>系统帮助</p>
            </div>
            <div class="img_block">
              <img src="@/assets/img/icon_regulation.png" />
              <p>政策法规</p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex_bottom">
        <div class="tab_wrap4_wrap fb_title">
          <span class="title">我的项目</span>
          <el-tabs v-model="projectName" @tab-click="handleProject" class="tab_wrap4">
            <el-tab-pane label="全部" name="defaultPJ"></el-tab-pane>
            <el-tab-pane label="招标项目" name="biddingPJ"></el-tab-pane>
            <el-tab-pane label="非招标项目" name="unbiddingPJ"></el-tab-pane>
          </el-tabs>
          <span class="detail">更多></span>
        </div>
        <el-table class="table_wrap1" :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="公告名称"></el-table-column>
          <el-table-column prop="publishDate" label="发布日期"></el-table-column>
          <el-table-column prop="endDate" label="截止日期"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
              <el-button type="text" size="small">报价</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  components: {},
  data() {
    return {
      flexData: [{ num: '0', title: '今日报价' }],
      messageNum: 0,
      activeName: 'default',
      projectName: 'defaultPJ',
      biddlist1: [],
      tableData: [
        // {
        //   name: "2020年频率计采购项目（第二次）”询价公告",
        //   publishDate: "2020-05-15 11:18",
        //   endDate: "2020-05-15 11:18"
        // },
        // {
        //   name: "2020年频率计采购项目（第二次）”询价公告",
        //   publishDate: "2020-05-15 11:18",
        //   endDate: "2020-05-15 11:18"
        // },
        // {
        //   name: "2020年频率计采购项目（第二次）”询价公告",
        //   publishDate: "2020-05-15 11:18",
        //   endDate: "2020-05-15 11:18"
        // },
        // {
        //   name: "2020年频率计采购项目（第二次）”询价公告",
        //   publishDate: "2020-05-15 11:18",
        //   endDate: "2020-05-15 11:18"
        // }
      ]
    }
  },
  created() {},
  computed: {},
  mounted() {
    this.getMessageNum()
    this.getInformationData('default')
  },
  methods: {
    getMessageNum() {
      let token = window.localStorage.getItem('loginToken')
      this.postRequest('/Message/Index', {
        loginToken: encodeURIComponent(token)
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.messageNum = res.data.messageNum
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    getInformationData(typeName) {
      var that = this
      let config = {}
      if (typeName == 'default') {
        config = {
          params: {
            showNum: 5
          }
        }
      } else {
        config = {
          params: {
            showNum: 5,
            typeName: typeName
          }
        }
      }

      this.getRequest('/Information/GetMemberCenterPart', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.biddlist1 = data.infoList
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    goInformationDetail(id, cateId) {
      let routerData = this.$router.resolve({
        name: 'detail',
        query: { id: id, cateId: cateId, purchaseType: 0 }
      })
      window.open(routerData.href, '_blank')
    },
    goMessageList() {
      let routerData = this.$router.resolve({
        name: 'MessageList'
      })
      window.open(routerData.href, '_blank')
    },
    goDetail() {
      this.$router.push('/Notify')
    },
    handleNotify() {
      this.getInformationData(this.activeName)
    },
    handleProject(val) {
      console.log(val)
    },
    handleSelect(val) {
      console.log(val)
    }
  }
}
</script>
<style scoped lang="scss">
.right_out {
  width: 98%;
  margin: 0 auto;
}
.welcome {
  height: 40px;
  line-height: 40px;
}

.block_wrap {
  display: flex;
}
.left_block {
  flex: 3;
  .flex_block {
    display: flex;
    .block {
      flex: 1;
      background: #fff;
      margin-right: 20px;
      text-align: center;
      align-items: center;
      padding: 13px 0;
      .text1 {
        font-size: 46px;
        color: #219cf8;
      }
      .text2 {
        margin-top: 4px;
        color: #054c81;
      }
    }
    .block:nth-last-of-type(1) {
      margin-right: 0;
    }
  }
}
.flex_bottom {
  padding: 10px 15px 3px;
  background: #fff;
  margin-top: 10px;
  .fb_title {
    margin-bottom: 0;
  }
}
.right_block {
  width: 220px;
  background: #fff;
  margin-left: 10px;
  padding: 18px 15px 0;
  .text {
    font-size: 16px;
    border-bottom: 1px solid #95c7f0;
    padding-bottom: 3px;
    font-weight: bold;
  }
  .row_imgs {
    display: flex;
    margin: 15px 0 25px;
    .img_block {
      flex: 1;
      text-align: center;
      cursor: pointer;
      img {
        margin-bottom: 20px;
      }
    }
  }
  .row_imgs:nth-last-of-type(1) {
    margin-top: 33px;
  }
}
</style>
